import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
// import { ReactSession } from "react-client-session";
import { ReactSession } from "../../../../lib/secure_reactsession";

import { saveFiveSecondResultQuestion } from "../../../../services/test_result";

import FiveSecondsTestIntroduction from "./five_seconds_test_introduction";
import FiveSecondsTestTask from "./five_seconds_test_task";
import { showToast } from "../../../../lib/helpers";

import TaskNotCompleted from "../../elements/TaskNotCompleted";
import GlobalQuestion from "../../global-question";

export default function FiveSecondsTest({
    test,
    result,
    questionCallback,
    callback,
    questionType,
    timeSpent,
}) {
    const location = useLocation();
    const [isActiveQuestion, setActiveQuestion] = useState(1);
    const [initialScreen, setInitialScreen] = useState(true);
    const [taskScreen, setTaskScreen] = useState(false);
    const [questionsScreen, setQuestionsScreen] = useState(false);
    const [totalQuestion, setTotalQuestion] = useState(0);
    const [QuestionArrayList, setQuestionArrayList] = useState([]);
    const [questionArray, setQuestionArray] = useState([]);
    const [questionLoading, setQuestionLoading] = useState(false);
    const [questionTimeSpend, setQuestionTimeSpend] = useState(0);
    const [skippedCount, setSkippedCount] = useState(0);

    useEffect(() => {
        let Questions = [];

        if (questionType === "Five Seconds Test Questions") {
            if (test && test.five_seconds_test_question.length) {
                setActiveQuestion(1);
                setTotalQuestion(test && test.five_seconds_test_question.length);

                test &&
                    test.five_seconds_test_question.forEach((items) => {
                        Questions.push({
                            data: items,
                            questionData: JSON.parse(items.questions),
                        });
                    });

                setQuestionArrayList(Questions);
            }
        }

        window.scrollTo(0, 0);

        function tickTime() {
            setQuestionTimeSpend((prevSeconds) => prevSeconds + 1);
        }
        let timeData = setInterval(() => tickTime(), 1000);

        return () => clearInterval(timeData);
    }, []);

    const handleNextQuestion = (formData) => {
        if (isActiveQuestion < totalQuestion) {
            window.scrollTo(0, 0);
            setQuestionArray([...questionArray, formData]);
            setActiveQuestion(isActiveQuestion + 1);
        } else {
            saveQuestionData([...questionArray, formData], false);
        }
    };

    const saveQuestionData = (formData, shouldNavigate) => {
        if (location.pathname.substr(1, 1) === "t") {
            let data = Object.assign({}, { questions: formData });
            data["test_id"] = result && result.test_id;
            data["result_id"] = result && result.id;
            data["question_type"] = questionType;
            data["guest_token"] = ReactSession.get("guest_token");
            data["time_spent"] = timeSpent;

            if (questionLoading) {
                return false;
            }

            if (!shouldNavigate) {
                setQuestionLoading(true);
            }

            if (shouldNavigate) {
                questionCallback(formData, questionType, false);
            }

            saveFiveSecondResultQuestion(data, ReactSession.get("token")).then(
                (response) => {
                    if (!shouldNavigate) {
                        setQuestionLoading(false);
                    }
                    if (response.success) {
                        callback();
                    } else {
                        showToast(response.message, "error");
                    }
                }
            );
        } else {
            callback();
        }
    };

    const taskHasError = () => {
        var error = false;

        if (test) {
            if (test.five_seconds_test_task && !test.five_seconds_test_task.task) {
                error = true;
            } else if (test.five_seconds_test_task && !test.five_seconds_test_task.task_file) {
                error = true;
            } else if (QuestionArrayList.length == 0) {
                error = true;
            }
        }
        return error;
    };

    return (
        <>
            {initialScreen &&
                <FiveSecondsTestIntroduction goToFirstTask={
                    () => {
                        setInitialScreen(false);
                        setTaskScreen(true);
                    }
                }
                    testlanguage={test.language}
                />
            }
            {taskScreen &&
                <>
                    {taskHasError()
                        ?
                        <TaskNotCompleted to={"/r/test/" + test.id + "/five-seconds-test"} />
                        :
                        <FiveSecondsTestTask goToFirstQuestion={
                            () => {
                                setTaskScreen(false);
                                setQuestionsScreen(true);
                            }
                        }
                            test={test}
                        />
                    }
                </>
            }
            {questionsScreen &&
                <div className="taking-test-page-wrap">
                    <div className="container">
                        {QuestionArrayList &&
                            QuestionArrayList.map((items, index) => {
                                return (
                                    <div key={index}>
                                        {isActiveQuestion === index + 1 && (
                                            <GlobalQuestion
                                                test={test}
                                                question={items}
                                                currentStep={isActiveQuestion}
                                                totalSteps={QuestionArrayList.length}
                                                onNext={handleNextQuestion}
                                                onSkip={() => {
                                                    if (items.questionData.is_optional) {
                                                        handleNextQuestion({
                                                            type: items.questionData.questionType,
                                                            question_id: items.data.id,
                                                            answer: "",
                                                            option_id: [],
                                                            is_skipped: 1,
                                                            question_time_spent: questionTimeSpend
                                                        });
                                                    }
                                                }}
                                                isOptional={items.questionData.is_optional}
                                                timeSpent={timeSpent}
                                                questionType={questionType}
                                                result={result}
                                                questionCallback={questionCallback}
                                                callback={callback}
                                                methodology="five_seconds"
                                                skippedCount={skippedCount}
                                                onSkipCountChange={setSkippedCount}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                    </div>
                </div>
            }
        </>
    );
}
